import { createContext } from "react";

const DEFAULT_API_KEY =
  "MTYxNmZmYzhhMTFkNjI2NjcwZDFhZTM0ZmRmYjliY2U2MTQ3ZGJjMDgxY2M4YWE1ODA0YTJjZDQ5OTkyZmUwM3ZhbGlkVW50aWw9NDcyOTQyNjk1NQ==";

export default createContext({
  appId: "EKEGGUH63H",
  apiKey: DEFAULT_API_KEY,
  environment: "development",
});
